import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StationMasterType } from '../../../context/MasterContextProvider';
import { URLs } from '../../../RouterConfig';
import ClickArea from '../../atoms/svg/ClickArea';

const STATION_WIDTH = 190;
const STATION_HEIGHT = 25;

type Props = {
  stations: Array<StationMasterType>;
};

// 電停上に透明なクリック領域を配置
const StationClicks: React.FC<Props> = (props) => {
  const { stations } = props;
  const navigate = useNavigate();

  return (
    <>
      {stations.map((station) => {
        const h = station.horizontal_flag_overview;

        const x = h
          ? station.x_overview - STATION_WIDTH / 2
          : station.x_overview - STATION_HEIGHT / 2;
        const y = h
          ? station.y_overview - STATION_HEIGHT / 2
          : station.y_overview - STATION_WIDTH / 2;

        const width = h ? STATION_WIDTH : STATION_HEIGHT;
        const height = h ? STATION_HEIGHT : STATION_WIDTH;

        return (
          <ClickArea
            x={x}
            y={y}
            width={width}
            height={height}
            onClick={() => {
              navigate(`${URLs.zoomMap}/${station.station_no}`);
            }}
            key={`station_click_${station.station_no}`}
          ></ClickArea>
        );
      })}
    </>
  );
};

export default React.memo(StationClicks);
